export default {
    AND: "и",
    OR: "или"
};
